import { Navigate } from "react-router-dom";
import { landingCompany } from "@/features/clients/hooks/use-preferred-company";
import { useMyClients } from "@/features/clients/hooks/use-clients";
import { useTranslation } from "@/features/utils/i18n";

export function HomeRedirect() {
  const { t } = useTranslation();
  const { data: clients, isLoading } = useMyClients();

  // Wait for the list: deciding on the empty default sent everyone to /start.
  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <div className="text-muted-foreground">{t("common.redirecting")}</div>
      </div>
    );
  }

  const company = landingCompany(clients ?? []);
  return (
    <Navigate to={company ? `/${company.client.id}/home` : "/start"} replace />
  );
}
